import { render, staticRenderFns } from "./UserModal.vue?vue&type=template&id=3b44ad04&scoped=true&"
import script from "./UserModal.vue?vue&type=script&lang=js&"
export * from "./UserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b44ad04",
  null
  
)

export default component.exports